window.addEventListener('load', () => {
  const observer = new MutationObserver((mutations) => {
    if(mutations){
      const yotpoStarRating = document.querySelector('.product-details .yotpo-widget-instance')
      const yotpoMainWidget = document.querySelector('.yotpo-main-widget')
      if(yotpoStarRating && yotpoMainWidget) {
        yotpoStarRating.addEventListener('click', () => {
          const rectData = yotpoMainWidget.getBoundingClientRect()
          window.scrollTo({
            top: rectData.top + window.scrollY,
            left: 0,
            behavior: 'smooth' 
          })
        })
        observer.disconnect()
      }
    }
  })

  observer.observe(document, {attributes: false, childList: true, characterData: true, subtree: true})
})
